import { Contact } from "@shared/types/UserAccountTypes.interface";
import { apiGet, apiPut } from "./apiHelper";

interface ContactPersonViewModel {
    id?: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    isPrimary?: boolean;
}

interface ContactPersonBookViewModel {
    customerNumber: string;
    dataAreaId: string;
    contactPersons: ContactPersonViewModel[];
}

interface ContactResponse {
    customerNumber: string;
    contacts: Contact[];
    statusCode: number;
}

export const fetchContacts = async (customerNumber: string): Promise<ContactResponse> => {
    const url = `/api/contactPersons/${customerNumber}`;
    const response = await apiGet<ContactPersonBookViewModel>(url);

    if (!response) {
        throw new Error("Failed to fetch contacts");
    }

    if (response.statusCode !== 200) {
        return { customerNumber, contacts: [], statusCode: response.statusCode };
    }

    return {
        customerNumber: response.data?.customerNumber ?? customerNumber,
        contacts: response.data?.contactPersons ?? [],
        statusCode: response.statusCode
    };
};

export const updateContacts = async (customerNumber: string, contacts: Contact[]): Promise<ContactResponse> => {
    const url = `/api/contactPersons`;
    const body: ContactPersonBookViewModel = {
        customerNumber,
        dataAreaId: "",
        contactPersons: contacts
    };

    const response = await apiPut<ContactPersonBookViewModel>(url, body);

    if (!response) {
        throw new Error("Failed to update contacts");
    }

    return {
        customerNumber,
        contacts,
        statusCode: response.statusCode
    };
};

export const matchContact = (contact: Contact, searchQuery: string): boolean => {
    const json = JSON.stringify(contact).toLowerCase();
    return json.includes(searchQuery.toLowerCase());
}
